import React, { useState } from "react";

const MediaPlayer = ({ mediaPlayerUrl }) => {
  //const [mediaType, setMediaType] = useState("audio"); // Se asume que es un video

  let mediaType = "";

  mediaPlayerUrl.includes("H264")
    ? (mediaType = "video")
    : (mediaType = "audio");

  console.log(mediaType);
  console.log(mediaPlayerUrl);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ maxWidth: "1000px", width: "100%" }}>
        <div style={{ display: "flex", justifyContent: "center" }}>
          {mediaType === "video" ? (
            <video
              controls
              width="600"
              style={{
                maxWidth: "100%",
                height: "60vh",
                width: "70%",
              }}
            >
              <source src={mediaPlayerUrl} type="video/mp4" />
              <source src={mediaPlayerUrl} type="video/webm" />
              <source src={mediaPlayerUrl} type="video/ogg" />
              Tu navegador no admite la reproducción de videos HTML5.
            </video>
          ) : (
            <audio
              controls
              style={{
                maxWidth: "100%",
                width: "100%",
                height: "10vh",
              }}
            >
              <source src={mediaPlayerUrl} type="audio/mpeg" />
              <source src={mediaPlayerUrl} type="audio/wav" />
              <source src={mediaPlayerUrl} type="audio/ogg" />
              <source src={mediaPlayerUrl} type="audio/mp3" />
              Tu navegador no admite la reproducción de audio HTML5.
            </audio>
          )}
        </div>
      </div>
    </div>
  );
};

export default MediaPlayer;
